import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {changePageTitle} from "../typescript/redux/actions";
import {Delete as DeleteIcon} from "@mui/icons-material";
import {Datatable} from "../index";
import {NeighborhoodService} from "./neighborhood.service";
import {useNavigate} from "react-router-dom";

export function NeighborhoodList() {

    let navigate = useNavigate();
    const [pageParams, setPageParams] = useState(null);
    const dispatch = useDispatch();

    const findAll = useCallback(async (number, size, sort, filter) => {
        const items = await NeighborhoodService.findAll(number, size, sort, filter);
        setPageParams({
            number: number,
            size: size,
            sort: sort,
            filter: filter,
            items: items
        });
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Bairros"));
        findAll(0, parseInt(process.env.REACT_APP_PAGE_SIZE), "id,asc", '').then();
    }, [dispatch, findAll]);

    const editItem = (item) => {
        navigate('/neighborhood/' + item.id);
    }

    const insertItem = () => {
        navigate('/neighborhood');
    }

    const deleteItem = (item) => {
        NeighborhoodService.delete(item.id).then(() => {
            findAll(pageParams.number, pageParams.size, pageParams.sort, pageParams.filter).then();
        }).catch(() => {

        })
    }

    const headerOperations = [
        {color: () => "primary", onClick: insertItem, label: () => 'Inserir'}
    ]

    const rowOperations = [
        {color: () => "primary", onClick: deleteItem, label: () => 'Excluir', icon: () => <DeleteIcon/>},
    ]

    return pageParams && (
        <Datatable dataColumnNames={['ID', 'Descrição']} dataColumns={['id', 'descricao']}
                   number={pageParams.number} size={pageParams.size} sort={pageParams.sort} filter={pageParams.filter}
                   dataTypes={['number', 'text']} findAll={findAll} editData={editItem}
                   data={pageParams.items.content} totalData={pageParams.items.totalElements}
                   headerOperations={headerOperations} rowOperations={rowOperations}/>
    );
}